import { useTranslation } from 'react-i18next';
import { gainItems } from '@/mocks/seminarData';

const GAIN_COUNT = 4;

export default function GainSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            WHAT YOU WILL GAIN
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('seminar.gain.altTitle')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
          {Array.from({ length: GAIN_COUNT }, (_, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-background-50 p-5 border border-background-200/60 group hover:border-accent-500/20 transition-colors duration-300"
            >
              <span className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className={[gainItems[index].icon, 'text-accent-600 text-lg group-hover:text-accent-500 transition-colors duration-300'].join(' ')}></i>
              </span>
              <div>
                <h4 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-1.5">
                  {t(`seminar.gain.${index}.title`)}
                </h4>
                <p className="text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em]">
                  {t(`seminar.gain.${index}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
